export default {
  phone: 'phone',
  email: 'email',
  enterpriseWeChat: 'Enterprise WeChat',
  ConsultationQrCode: 'Consultation QrCode',
  items: ['1e','2','3', '4','5'],
  navBar: {
    home: 'Home',
    groupOverview: 'GroupOverview',
    companyOverview: 'CompanyOverView',
    coreValue: 'CoreValue',
    subCompany: 'BranchStructure',
    businessScope: 'BusinessScope',
    featureService: 'FeatureService',
    internationalShipping: 'InternationShipping',
    internationalAir: 'InternationAir',
    internationalTruck: 'InternationTruck',
    huanshuntongTechnology: 'Technology',
    digitalPlatform: 'ProductDigitalizationPlatform',
    interactivePlatform: 'CustomerInteractivePlatform',
    visualPlatform: 'LogisticsVisualizationPlatform',
    newsCenter: 'NewsCenter',
    newsDetail: 'NewsDetail',
    humanResource: 'HumanResource',
    talentConcept: 'TalentConcept',
    joinUs: 'Join Us',
    contactUs: 'contactUs',
    contactCompany: 'ContactGroup',
    contactPort: 'ContactPort',
  },
  homePage: {
    bannerTitle: 'Huanshuntong Supply Chain',
    bannerText: 'Your ideal logistics partner, providing an end-to-end digital freight forwarding platform',
    groupIntro: 'Group Introduction',
    groupIntroText: "Huanshuntong's supply chain began in 2018, operating with a one-stop, comprehensive, and one-stop characteristic, providing safe, stable, and fast international logistics services to help Chinese manufacturing achieve global intelligence; The product network of Huanshuntong channel covers major e-commerce trading countries and regions such as the United States, the European Union, the United Kingdom, Canada, Mexico, Japan, and Australia. A strong overseas team ensures smooth customs clearance and distribution services at the destination port, providing safe and stable multimodal logistics solutions with full time coverage of sea, land, and air.",
    serviceIntro: 'Business Introduction',
    meitongAir: 'HuanShunTong Air Transport',
    meitongShip: 'HuanShunTong Shipping',
    meitingTruck: 'HuanShunTong Road Transport',
    meitongStorage: 'Overseas warehouse',
    newsCenter: 'News Center',
    moreNews: 'More News',
  },
  companyPage: {
    groupIntro: 'Group Introduction',
    introText: "Founded in 2018, HuanShunTong(HST) operates with a one-stop, comprehensive, and one-stop approach, providing safe, stable, and fast international logistics services to assist Chinese manufacturing in achieving global intelligence.<br/>The HuanShunTong channel product network covers major e-commerce trading countries and regions such as the United States, the European Union, the United Kingdom, Canada, Mexico, Japan, and Australia. A strong overseas team ensures smooth customs clearance and delivery services at the destination port, providing safe and stable sea, land, and air full time coverage multimodal logistics solutions.<br/>HuanShunTong became a key credit certification enterprise in Credit China in July 2023, was selected for the Amazon Service Provider Network (Amazon SPN) in August 2023, became an Amazon ShipTrack service provider in February 2024, became an Amazon TSPN service provider and SEND logistics carrier in March 2024, and won the Top 10 FBA Logistics Enterprises in the Xiaosheng Ranking for four consecutive years from 2020 to 2024. In October 2023, it won honors such as Amazon's 2023 Gold Medal Assistance and SPN First Year Award. In February 2024, it won the Hugo Cross border 2023 Best Cross border Logistics Award. In September 2024, it won the Excellent FBA Logistics Service Provider award at the China International Fair for Trade in Goods, and in December 2024, it won the China Cross border E-commerce Logistics Top 10 Enterprises award. Honors such as Top Ten Logistics Service Providers.<br/>HuanShunTong is headquartered in Shenzhen with an office area of over 7000 square meters. It has established 20 branches in Guangzhou, Zhongshan, Foshan, Dongguan, Shanghai, Yiwu, Zhengzhou, Qingdao, Changsha, Hefei, Ningbo, Xiamen, Chengdu, Hangzhou, Xinjiang and other places in China. Overseas, it has established 20 branches in Canada, the United States, Mexico, the United Kingdom, Belgium, Germany, France, Japan, Belarus, Vietnam, Kazakhstan and other places, with over 1000 employees worldwide. HuanShunTong has over 80 self operated routes, with a domestic storage area of over 60000 square meters and a self operated overseas warehouse area of over 50000 square meters. Its strong infrastructure and professional team provide guarantees for diversified logistics and distribution needs.<br/>HuanShunTong has been focusing on cross-border e-commerce logistics for 10 years, continuously improving its domestic sales network and expanding its product line to cover destination countries. It is focusing on achieving a closed-loop operation of core market services, transforming from information technology to digitalization, and achieving basic controllability and visualization of key operational control points, in order to become a leading cross-border e-commerce logistics enterprise in the industry.",
    feature1: 'One-Stop',
    feature2: 'All-in-One',
    feature3: 'End-to-End',
    rightTitle: 'One-Stop',
    rightText: 'Establish multiple branch companies to provide localized services for customers nationwide'
  },
  coreValuePage: {
    coreValue: 'Core Values',
    whishGoal: 'Corporate Vision and Goals',
    whish: 'Corporate Vision',
    whishText: 'A preferred global logistics platform for cross-border e-commerce, helping Chinese manufacturing reach the world safely, stably, and quickly with intelligence',
    goal: 'Five-Year Goal',
    goalText: 'Assist 50,000 cross-border e-commerce enterprises in successfully expanding overseas',
    concept: 'Core Values',
    concept1: 'Open Collaboration',
    concept2: 'Unity and Striving',
    concept3: 'Honesty and Integrity',
    concept4: 'Exploration and Innovation',
  },
  featureBranchPage: {
    branchTitle: 'Branch Structure',
    branch: [
      {
        name: 'Shenzhen Headquarters',
        address: 'Building 9, 105, Jinfanghua E-commerce Industrial Park, No. 49 South Banhe Avenue, Bantian, Longgang District, Shenzhen; Building A1001-A1004, Bayin Valley, No. 26 Yayuan Road, Longgang District, Shenzhen'
      },
      {
        name: 'Airport Branch',
        address: 'Units 1501-04-A1004, Huaide International Building, Fuyong Street, Baoan District, Shenzhen'
      },
      {
        name: 'Guanlan Branch',
        address: 'Hongmu Market, Dadi City, No. 17 Guantian Road, Niuhu Community, Guanlan Street, Longhua District, Shenzhen'
      },
      {
        name: 'Guangzhou Branch',
        address: 'F202-206, Pengshang Technology Industrial Park, Baiyun District, Guangzhou'
      },
      {
        name: 'Zhongshan Branch',
        address: 'Units 4701-03, Lihe International Financial Center, Dong District, Zhongshan'
      },
      {
        name: 'Foshan Branch',
        address: 'Shop 118-125, First Floor, Building 18, Shunlian Zhizaohui, Shunde District, Foshan'
      },
      {
        name: 'Dongguan Branch',
        address: 'Room 3503, Block A, Building 9, Huanyu Huijin Center, Nancheng Street, Dongguan'
      },
      {
        name: 'Shanghai Branch',
        address: 'Rooms 606-607, Building A, No. 358 Yinxi Road, Songjiang District, Shanghai'
      },
      {
        name: 'Yiwu Branch',
        address: 'Unit 5, Building 1, Boni Industrial Park, No. 129 Chunhan Road, Beiyuan Street, Yiwu City, Zhejiang Province (HuanShunTong Supply Chain)'
      },
      {
        name: 'Zhengzhou Branch',
        address: 'Room 2-368, Yunshidai Plaza, No. 20 Wenzhi Road, Guancheng Hui District, Zhengzhou'
      },
      {
        name: 'Qingdao Branch',
        address: 'Unit 5, Building 1, Boni Industrial Park, No. 129 Chunhan Road, Beiyuan Street, Yiwu City, Zhejiang Province (HuanShunTong Supply Chain)'
      },
      {
        name: 'Hefei Branch',
        address: 'Room 2-368, Yunshidai Plaza, No. 20 Wenzhi Road, Guancheng Hui District, Zhengzhou'
      },
      {
        name: 'Ningbo Branch',
        address: 'Unit 5, Building 1, Boni Industrial Park, No. 129 Chunhan Road, Beiyuan Street, Yiwu City, Zhejiang Province (HuanShunTong Supply Chain)'
      },
      {
        name: 'Changsha Branch',
        address: 'Room 2-368, Yunshidai Plaza, No. 20 Wenzhi Road, Guancheng Hui District, Zhengzhou'
      },
      {
        name: 'Xiamen Branch',
        address: 'Unit 5, Building 1, Boni Industrial Park, No. 129 Chunhan Road, Beiyuan Street, Yiwu City, Zhejiang Province (HuanShunTong Supply Chain)'
      },
      {
        name: 'Chengdu Branch',
        address: 'Room 2-368, Yunshidai Plaza, No. 20 Wenzhi Road, Guancheng Hui District, Zhengzhou'
      }
    ],
  },
  featureServicePage: {
    featureTitle: 'Featured Services',
    feature1: {
      title: 'Diversified',
      text: 'Various diversified featured services to meet multiple needs'
    },
    feature2: {
      title: 'Professional',
      text: 'Professional team support, reliable and worry-free'
    },
    feature3: {
      title: 'Service',
      text: 'Enthusiastic and loyal, providing the highest quality service'
    },
    description1: {
      title: 'Cambodia Customs Clearance',
      text: 'For goods shipped from Chinese ports to Cambodia, we provide customs clearance services in Phnom Penh. First-phase product: customs clearance service for tiles in Phnom Penh, applicable for shipments from Qingdao, Guangdong, and Xiamen.'
    },
    description2: {
      title: 'Malaysia Transit Trade',
      text: 'Shipments from any Chinese port (Tianjin, Qingdao, Shanghai, Ningbo, Shenzhen, Guangzhou, etc.), transiting through Malaysia for customs clearance, container transfer, vessel change, and onward transport to the US. Both buyers and sellers need to be informed, prepare relevant LC terms, use neutral packaging, and obtain third-country certificates of origin during transit.'
    },
    description3: {
      title: 'Overseas Warehousing',
      text: 'For goods exported from major Chinese ports to the Philippines, we provide customs clearance services covering a wide range of products including daily necessities, sundries, mechanical and electrical equipment.'
    },
    description4: {
      title: 'Project Logistics & Special Containers',
      text: '1. End-to-end international logistics for oversized cargo (including domestic and international factory relocations) 2. Small/medium equipment transport via special containers 3. Bulk cargo transport and chartering services 4. Dangerous goods container shipping 5. Containerized goods import'
    },
    description5: {
      title: 'India Extended Services',
      text: 'With hubs at Navi Mumbai (West Coast) and Chennai (East Coast), we provide premium services across India including Andhra Pradesh, Assam, Bihar, Goa, Gujarat, Haryana, Himachal Pradesh, Karnataka, Kerala, Madhya Pradesh, Maharashtra, Manipur, Meghalaya, Mizoram, Nagaland, Odisha, Punjab, Rajasthan, Tamil Nadu, Tripura, Uttar Pradesh, and West Bengal.'
    },
    description6: {
      title: 'Recycled Plastics Cross-Border Logistics',
      text: 'Shunyuan Logistics Malaysia subsidiary provides comprehensive solutions for recycled plastic pellet trade: handling Malaysian waste imports and finished product exports, assisting clients without recycling qualifications by providing import permits and documentation services to resolve core trade pain points.'
    },
  },
  internationShippingPage: {
    featureTitle: 'International Shipping',
    featureText: 'We partner with world-class shipping companies to offer competitive pricing and ample space, ensuring your cargo arrives as scheduled',
    feature1: {
      title: 'High Efficiency',
      text: 'We use cutting-edge technology to manage trade complexities, reducing time, cost, and effort.'
    },
    feature2: {
      title: 'Low Cost',
      text: 'We provide detailed and transparent ocean freight quotes with no hidden fees.'
    },
    feature3: {
      title: 'Visibility',
      text: 'Monitor shipments via our intuitive tracking system with end-to-end visibility for peace of mind.'
    },
    description1: {
      title: 'US FCL Imports/Exports & Huanshuntong LCL',
      text: 'Advanced one-stop platform, competitive pricing, guaranteed space, and dedicated US team. Specializing in Europe/US routes with comprehensive services. Handles global LCL imports/exports with extensive agent network and professional inland connections.'
    },
    description2: {
      title: 'Stable & Reliable Freight',
      text: 'We select optimal carrier schedules based on your transit time requirements to ensure on-time delivery for critical shipments.'
    },
  },
  internationAirPage: {
    featureTitle: 'International Air Freight',
    featureText: 'We collaborate with leading airlines and cargo agents to provide cost-effective air solutions through a robust platform, along with customized services for diverse needs.',
    feature1: {
      title: 'Real-time Monitoring',
      text: 'Proprietary technology enables 24/7 cargo tracking for on-time, secure delivery.'
    },
    feature2: {
      title: 'Competitive Pricing',
      text: 'Optimized consolidation solutions to reduce costs.'
    },
    feature3: {
      title: 'Customized Service',
      text: 'Dedicated team designs personalized solutions to save time, effort, and money.'
    },
    description1: {
      title: 'Huanshuntong Air Freight',
      text: 'Specializing in Europe/US/Southeast Asia routes. Comprehensive airport network, proprietary brand and warehouses. Premium KE US direct flights, CI US air-air transfers, CZ BSA charters.'
    },
    description2: {
      title: 'Powerful Supplier Network',
      text: 'Our air experts handle all cargo types promptly. Supported by a global network of leading partners for seamless import/export air services.'
    },
  },
  internationTruckPage: {
    featureTitle: 'China-Europe Trucking',
    featureText: 'Real-time platform tracking and premium carrier network ensure safe, on-time delivery.',
    feature1: {
      title: 'Freight Platform',
      text: 'Drivers access cargo info directly, update delivery progress in real-time, and contact clients when needed.'
    },
    feature2: {
      title: 'Transparent Pricing',
      text: 'Traditional trucking costs are complex. Our platform displays all charges for easy quote/invoice comparison.'
    },
    feature3: {
      title: 'Logistics Visibility',
      text: 'Real-time updates ensure on-time delivery. Safround platform simplifies warehouse operations.'
    },
    description1: {
      title: 'Pan-Southeast Asia Trucking',
      text: 'Two routes: Route 1: China (NGB,SHA,SZ,HK) → Hanoi → Laos → Bangkok → Kuala Lumpur → Singapore. Route 2: China (NGB,SHA,SZ,GX) → Hanoi → Ho Chi Minh City → Phnom Penh'
    },
    description2: {
      title: 'Stable & Reliable Freight',
      text: 'Huanshun partners with major carriers/NVOCCs for reliable ocean services. Transparent quotes include destination charges (THC, port fees, settlement fees, documentation).'
    },
  },
  digitalPlatformPage: {
    bannerTitle: 'Product Digitalization Platform',
    bannerText: 'Easyda, founded by Shunyuan Logistics Group, launched in April 2017. Headquartered in Ningbo with branches in Shenzhen, Xiamen, Shanghai, Jiaxing, Qingdao, Dalian, Tianjin, and Southeast Asia. Offers online inquiry, booking, and cargo tracking to provide self-operated premium routes across China and Southeast Asia, establishing a fast end-to-end visible logistics channel.',
    feature1: {
      title: 'Efficiency',
      text: 'Quick and precise search based on needs'
    },
    feature2: {
      title: 'Comprehensive Information',
      text: 'Multiple functions and complete information for all business queries'
    },
    feature3: {
      title: 'Visibility',
      text: 'Monitor processes with full cargo tracking'
    },
    description1: {
      title: 'Advanced Logistics Expert',
      text: 'Simplified one-click inquiries. Ocean/land/air teams provide real-time updates. Massive online booking options. Easyda integrates smart tech for visible logistics, leading new trends in global supply chains.'
    },
    description2: {
      title: 'Your Easyda Solution',
      text: 'Core focus: North America routes (ranked #22 globally by JOC for Far East-NA exports). Comprehensive services: US export e-commerce logistics, non-US routes, air/rail freight. Self-operated internet freight model delivers efficient, high-quality service across Chinese ports.'
    },
  },
  interactivePlatformPage: {
    bannerTitle: 'Customer Interactive Platform',
    bannerText: 'Communication is information exchange. We create interactive platforms<br/> where communication is embedded in every process.',
    feature1: {
      title: 'Time & Effort Saving',
      text: 'Break traditions, eliminate complex switching'
    },
    feature2: {
      title: 'Targeted',
      text: 'Logistics-node based communication with clear visibility'
    },
    feature3: {
      title: 'Personalized',
      text: 'Unique interfaces create new communication possibilities'
    },
    description1: {
      title: 'Customer Interaction Innovation',
      text: 'Every collaboration node becomes a communication context. Our optimized platform eliminates messy emails/texts by integrating logistics visibility with communication.'
    },
    description2: {
      title: 'New Interactive Experience',
      text: 'Humanized omnichannel interaction combining assisted/self-service. Experience smart interactions from inquiry to order – dedicated to customer service.'
    },
  },
  visualPlatformPage: {
    bannerTitle: 'Logistics Visualization Platform',
    bannerText: 'An information platform for cargo tracking that efficiently connects partners across the supply chain, enabling execution monitoring and visibility to meet modern logistics demands.',
    feature1: {
      title: 'Convenience',
      text: 'Instant queries, no waiting'
    },
    feature2: {
      title: 'Accuracy',
      text: 'Reliable information sources'
    },
    feature3: {
      title: 'Real-time',
      text: 'Immediate updates'
    },
    description1: {
      title: 'Logistics Distribution Visibility',
      text: 'Replace manual/email-based processes with error-prone tracking. Shunyuan\'s advanced platform provides real-time node visibility, anytime/anywhere shipment monitoring, and online status checks to enhance service quality and satisfaction.'
    },
    description2: {
      title: 'Your Supply Chain "Radar"',
      text: 'Covers 1000+ global ports. Full-process controllability with real-time tracking and vessel positioning. Eliminates communication delays for efficient operations and seamless cargo-client connectivity.'
    },
  },
  contactPortPage: {
    bannerTitle: 'Freight Ports',
    port:[
      {
        city: 'Ningbo',
        address: 'Location: 17F, Hongtai Dibiao Building, No. 1222 Ningchuan Road, Yinzhou District, Ningbo'
      },
      {
        city: 'Shanghai',
        address: 'Location: Rooms 612-619, No. 386 Guoan Road, Yangpu District, Shanghai'
      },
      {
        city: 'Jiaxing',
        address: 'Location: Room 1901, Block A, Jianrui Building, Nanhu District, Jiaxing City, Zhejiang'
      },
      {
        city: 'Nanjing',
        address: 'Location: Room 4102, Tower A, Golden Eagle Mall, No. 89 Hanzhong Road, Nanjing, Jiangsu'
      },
      {
        city: 'Qingdao',
        address: 'Location: Rooms 1206-08, Tower B, China Resources Building, No. 6 Shandong Road, Shinan District, Qingdao'
      },
      {
        city: 'Tianjin',
        address: 'Location: Room 4805, Tianjin Global Financial Center, No. 2 Dagu North Road, Heping District, Tianjin'
      },
      {
        city: 'Shenzhen',
        address: 'Location: Units F-G-H, 3F, Node Center, No. 1006 Fuzhong 3rd Road, Futian District, Shenzhen'
      },
      {
        city: 'Xiamen',
        address: 'Location: Room 701, Building D, Xiamen International Shipping Center, No. 97 Xiangyu Road, Xiamen FTZ (Fujian)'
      },
      {
        city: 'Malaysia',
        address: 'Location: NO.28 (3RD FLOOR) JALAN TIARA 2A/KU1, BANDAR BARU KLANG, 41150 KLANG, SELANGOR, MALAYSIA'
      },
      {
        city: 'Vietnam',
        address: 'Location: 207 NGUYEN VAN TROI STREET, WARD 10, PHU NHUAN DISTRICT, HO CHI MINH CITY, VIETNAM'
      },
      {
        city: 'Cambodia',
        address: 'Location: 5F Vanda Tower, Block 79, Kampucheakrom Blvd,Sangkat Monorom, 7 Makara District,Phnom Penh, Cambodia.'
      },
      {
        city: 'Thailand',
        address: 'Location: 26/56 TPI Tower Bldg, 21th Floor Nang Lin Chi Rd, Thungmahamek,Sathorn, BKK 10120'
      },
    ]
  },
  newsCenterPage: {
    newsCenter: 'News Center',
    huanshuntongNews: 'huanshuntong News',
    back: 'back'
  },
  talentConceptPage: {
    bannerTitle: 'huanshuntong has you',
    bannerText: 'We are waiting for you to join us',
    bannerBtn: 'View Position',
    moduleTitle: 'Talent Concept',
    moduleText: 'The talent concept represents a company\'s guiding ideology and values for valuing, caring for, reasonably developing, utilizing, retaining, and enhancing talents. Excellent talents form the foundation for achieving corporate strategic goals and serve as the driving force for sustainable development. The company attracts outstanding talents through scientific talent cultivation methods, effective incentive mechanisms, fair competition platforms, and broad career development spaces. We intensify efforts in human resource "selection, cultivation, utilization, and retention" to continuously optimize personnel quality structure. This enables every employee to fully realize their self-worth within the organization, achieving optimal alignment between personal career plans and corporate development objectives, fostering mutual growth for both employees and the company.',
    featureTitle1: 'Combining Integrity with Ability',
    featureText1: '"Talent supports virtue; virtue commands talent." "Virtue" signifies high fundamental qualities, while "ability" represents the basic capacity to fulfill job responsibilities. As the ancients said: "A foot may be too short in some cases; an inch may be long enough in others. Everything has its imperfections; wisdom has its limitations." In selecting and employing people, we don\'t demand perfection in both, but prioritize virtue first. We promote ability through virtue and cultivate virtue through ability. By enhancing the quality of corporate talent, we build a talent structure that combines both integrity and ability.',
    featureTitle2: 'Maximizing Every Talent',
    featureText2: 'People have strengths and weaknesses regardless of stature. We value both character and competence, embracing both internal and external qualities. Know people well and put them to best use. Recognize talent with discernment, cherish talent with passion, employ talent with magnanimity, promote talent with courage, and embrace talent with broad-mindedness. We deeply explore the strengths of each employee, fully leverage their advantages, and maximize the integration of corporate talent resources. This provides powerful momentum for sustainable development, propelling the enterprise into the fast lane of healthy growth.',
    readTitle: 'Are you ready to join HuanshunTong?',
    viewAllJob: 'View All Position',
  },
  joinUsPage: {
    bannerTitle: 'Recruiting Talent and Virtue',
    bannerInput: 'Job Title / Work Location / Education Requirement',
    bannerBtn: 'View Position',
    applyBtn: 'Apply Position'
  },
  contactCompanyPage: {
    bannerTitle: 'Group Contact',
    contactWay1: {
      name: 'Media Liaison',
    },
    contactWay2: {
      name: 'Legal Liaison',
    },
    contactWay3: {
      name: 'Business cooperation',
    },
  }
}